import ro from './translation'

//Write here all the changes to translations that are not correct
ro.messages.cart.amountItems = "{amount} articol unic"
ro.messages.cart.amount = "{amount} poziții de articol"
export default ro
